'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var removeNulls = function removeNulls(array) {
  return array.filter(function (x) {
    return x !== null;
  });
};

var anythingIsUndefined = function anythingIsUndefined() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return values.some(function (val) {
    return typeof val === 'undefined';
  });
};

exports.default = function (_ref) {
  var searchQuery = _ref.searchQuery,
      sortMode = _ref.sortMode;

  if (!searchQuery || !Array.isArray(sortMode)) {
    return null;
  }

  var viewModel = removeNulls(sortMode.map(function (_ref2) {
    var name = _ref2.name,
        value = _ref2.value,
        isActive = _ref2.isActive;

    if (anythingIsUndefined(name, value, isActive)) {
      return null;
    }

    return _extends({
      label: name,
      value: value,
      isActive: isActive
    }, isActive ? {} : {
      refineParams: _extends({}, searchQuery, {
        sortmode: value
      })
    });
  }));

  return viewModel.length === 0 ? null : viewModel;
};

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-refine-job-search/dist/view-models/sort-mode/sort-mode.js
 ** module id = 490
 ** module chunks = 0
 **/